import React from 'react';
import '../styles/TermsPage.css';
import { useI18n } from '../../i18n/I18nProvider';

const TermsPage = () => {
  const { t } = useI18n();
  
  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1 className="terms-title">{t('terms.title')}</h1>
        
        <div className="terms-intro">
          <p>{t('terms.intro')}</p>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.acceptance.title')}</h2>
          <p>{t('terms.acceptance.content')}</p>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.useLicense.title')}</h2>
          <p>{t('terms.useLicense.content')}</p>
          <ul className="terms-list">
            {t('terms.useLicense.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.serviceDescription.title')}</h2>
          <p>{t('terms.serviceDescription.content')}</p>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.userAccounts.title')}</h2>
          <p>{t('terms.userAccounts.content')}</p>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.privacyPolicy.title')}</h2>
          <p>{t('terms.privacyPolicy.content')}</p>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.prohibitedUses.title')}</h2>
          <p>{t('terms.prohibitedUses.content')}</p>
          <ul className="terms-list">
            {t('terms.prohibitedUses.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.limitationOfLiability.title')}</h2>
          <p>{t('terms.limitationOfLiability.content')}</p>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.governingLaw.title')}</h2>
          <p>{t('terms.governingLaw.content')}</p>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.changesToTerms.title')}</h2>
          <p>{t('terms.changesToTerms.content')}</p>
        </div>

        <div className="terms-section">
          <h2 className="terms-subtitle">{t('terms.contactInformation.title')}</h2>
          <p>{t('terms.contactInformation.content')}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
